import { render, staticRenderFns } from "./DocTemplateVariablesItem.vue?vue&type=template&id=54a36569&"
import script from "./DocTemplateVariablesItem.vue?vue&type=script&lang=ts&"
export * from "./DocTemplateVariablesItem.vue?vue&type=script&lang=ts&"
import style0 from "./DocTemplateVariablesItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports